import api from '../utils/axios';

export const versionControlApi = {
  async revertToCheckpoint(projectId: string, threadId: string, messageId: string) {
    const response = await api.post(
      `/dev-agent/projects/${projectId}/threads/${threadId}/revert`,
      { message_id: messageId }
    );
    return response.data;
  },

  async getVersionedChatHistory(
    projectId: string,
    threadId: string,
    limit?: number,
    beforeMessageId?: string,
    afterMessageId?: string,
  ) {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    if (beforeMessageId) params.append('before_message_id', beforeMessageId);
    if (afterMessageId) params.append('after_message_id', afterMessageId);
    const qs = params.toString();
    const response = await api.get(
      `/dev-agent/projects/${projectId}/threads/${threadId}/chat-history${qs ? `?${qs}` : ''}`
    );
    return response.data;
  },

  async getChatIndex(projectId: string, threadId: string, segmentId?: string) {
    const qs = segmentId ? `?segment_id=${segmentId}` : '';
    const response = await api.get(
      `/dev-agent/projects/${projectId}/threads/${threadId}/chat-index${qs}`
    );
    return response.data as {
      items: { id: string; timestamp: number; preview: string }[];
      count: number;
    };
  },

  async getSegmentMessages(
    projectId: string,
    threadId: string,
    segmentId: string,
    limit?: number,
    beforeMessageId?: string,
    afterMessageId?: string,
  ) {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    if (beforeMessageId) params.append('before_message_id', beforeMessageId);
    if (afterMessageId) params.append('after_message_id', afterMessageId);
    const qs = params.toString();
    const response = await api.get(
      `/dev-agent/projects/${projectId}/threads/${threadId}/segments/${segmentId}/messages${qs ? `?${qs}` : ''}`
    );
    return response.data;
  },

  async gitPull(projectId: string, discardLocalChanges = false) {
    const response = await api.post(`/dev-agent/projects/${projectId}/git/pull`, {
      discard_local_changes: discardLocalChanges,
    });
    return response.data;
  },

  async gitPush(projectId: string, commitMessage?: string) {
    const response = await api.post(`/dev-agent/projects/${projectId}/git/push`, {
      commit_message: commitMessage || null,
    });
    return response.data;
  },

  async gitSyncStatus(projectId: string) {
    const response = await api.get(`/dev-agent/projects/${projectId}/git/sync-status`);
    return response.data;
  },

  async gitClone(projectId: string) {
    const response = await api.post(`/dev-agent/projects/${projectId}/clone`, {});
    return response.data;
  },

  async resetGitToken(projectId: string) {
    const response = await api.post(`/dev-agent/projects/${projectId}/token/reset`);
    return response.data;
  },
};
